import { ISupportee } from '../../shared';
import { ISupporteeForm } from '../models';
import { mapDateToApiDate } from './date-string.mapper';
import { getLanguage, getNationality } from '../../shared/utils/origins.util';

export function supporteeMapperFromForm(
    supportee: ISupporteeForm,
    relations: { value: string; translation: string }[],
): ISupportee {
    return {
        ...supportee,
        language: supportee.language?.code || '',
        nationality: supportee.nationality?.code || '',
        relation:
            relations.find((relation) => relation.translation.toLowerCase() === supportee.relation?.toLowerCase())
                ?.value || supportee.relation,
        dateOfBirth: mapDateToApiDate(supportee.dateOfBirth),
        gender: supportee.gender || null,
        dependencyPercentage:
            typeof supportee.dependencyPercentage === 'number' ? supportee.dependencyPercentage : undefined,
    };
}

export function supporteeMapperToForm(supportee: ISupportee): ISupporteeForm {
    return {
        ...supportee,
        firstName: supportee.firstName ? supportee.firstName : '',
        lastName: supportee.lastName ? supportee.lastName : '',
        nationalSecurityNumber: supportee.nationalSecurityNumber ? supportee.nationalSecurityNumber : '',
        language: getLanguage(supportee.language) || null,
        nationality: getNationality(supportee.nationality) || null,
        dateOfBirth: supportee.dateOfBirth ? new Date(supportee.dateOfBirth) : null,
        gender: supportee.gender || '',
    };
}
